/**
 * Legacy PriceApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.priceApi`) keep resolving.
 *
 * The actual PriceApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/price/price-api.service.ts
 */
angular.module("acme.common.service.priceApi", [
  "acme.common.factory.QueryStringBuilder",
  "acme.common.factory.apiVersion",
]);
